import { IMemberEventsDate } from '@shared/shared/interfaces/member-event.interfaces';
import * as UrlLib from '@shared/utils/url.lib';
import * as fromActions from '../actions/member-event-date.actions';

export const initialState: IMemberEventsDate = {
  url: null,
};

export function reducer(state = initialState, action: fromActions.MemberEventDateActions) {
  switch (action.type) {
    case fromActions.GET_EVENT_DATE:
      return initialState;

    case fromActions.GET_EVENT_DATE_SUCCESS: {
      const id = Object.prototype.hasOwnProperty.call(action.payload, 'url')
        ? { id: UrlLib.extractId(action.payload.url) }
        : {};

      return {
        ...action.payload,
        ...id,
      };
    }

    default:
      return state;
  }
}
